export const LOGIN = 'LOGIN';
export const BANKID_PROGRESS = 'BANKID_PROGRESS';
export const LOGIN_BANKID = 'LOGIN_BANKID';
export const FREJAID_PROGRESS = 'FREJAID_PROGRESS';
export const LOGIN_FREJAID = 'LOGIN_FREJAID';
export const NETID_PROGRESS = 'NETID_PROGRESS';
export const LOGIN_NETID = 'LOGIN_NETID';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const SELECT_CLIENT = 'SELECT_CLIENT';
export const BANKID_QRCODE = 'BANKID_QRCODE';
export const RESET_TOKEN = 'RESET_TOKEN';
export const CLEAR_REDUCER = 'CLEAR_REDUCER';
export const LOGIN_SELF_REGISTRATION = 'LOGIN_SELF_REGISTRATION';
export const REFRESH_TOKEN_DATE = 'REFRESH_TOKEN_DATE';
export const RESET_MFA_LOGIN = 'RESET_MFA_LOGIN';
export const SWITCH_CLIENT = 'SWITCH_CLIENT';
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';
